import React from "react";
import Head from "next/head";
import StdInfoHeader from "root/components/StdInfoHeader";
import { Box, Typography } from "root/components/design-system";
import theme from "root/config/theme";

export default function MaintenancePage() {
  return (
    <>
      <Head>
        <title>Under Maintenance | Dissrup</title>
      </Head>
      <Box
        position="absolute"
        top="0"
        height="100vh"
        width={1}
        background="linear-gradient(180deg, #BCBCBC 0%, #FFFFFF 26.79%)"
        zIndex="0"
      />
      <Box position="relative" pt="120px" height="100vh">
        <Box maxWidth="517px" m="auto">
          <Typography
            fontSize="24px"
            fontWeight="bold"
            textAlign="center"
            mb="36px"
          >
            We are currently undergoing some planned maintenance. We’ll be up
            and running again shortly
          </Typography>
        </Box>
        <StdInfoHeader text="BACK SOON" xl color={theme.colors.blue} />
      </Box>
    </>
  );
}

// Force page to be statically-rendered
export async function getStaticProps() {
  return {
    props: {
      loginDisabled: true,
    },
  };
}
